<template>
  <div>
       <MyHeader/>
       <LeftMenu/>
       <div class="rightpage">
          <MySeach/>
          <RightModule/>
       </div>
  </div>
</template>

<script>
import MyHeader from './MyHeader'
import LeftMenu from './LeftMenu'
import MySeach from './MySeach'
import RightModule from './RightModule'

export default {
    name:'MainPage',
    components: {
    MyHeader,
    LeftMenu,
    MySeach,
    RightModule
}
}
</script>

<style>
  .rightpage{
    margin: 0em 0em 0em 280px;
  }
</style>